"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextField = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextField = require("./TextField.styled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var TextField = function TextField(props) {
  var error = props.error,
      errorMessage = props.errorMessage,
      _onChange = props.onChange,
      _onFocus = props.onFocus,
      _onBlur = props.onBlur,
      rest = _objectWithoutProperties(props, ["error", "errorMessage", "onChange", "onFocus", "onBlur"]);

  return _react.default.createElement(_TextField.StyledTextFieldContainer, null, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_TextField.StyledTextField, _extends({}, rest, {
    error: error,
    onChange: function onChange(e) {
      return _onChange(e);
    },
    onFocus: function onFocus(e) {
      return _onFocus(e);
    },
    onBlur: function onBlur(e) {
      return _onBlur(e);
    }
  })), error && _react.default.createElement(_TextField.StyledErrorMessage, null, errorMessage)));
};
/**
 * Definition of default values for component props
 */


exports.TextField = TextField;
TextField.defaultProps = {
  id: undefined,
  name: undefined,
  placeholder: undefined,
  value: '',
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  width: 'auto',
  error: false,
  errorMessage: undefined,
  disabled: false,
  type: 'text'
};
TextField.propTypes = {
  id: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  width: _propTypes.default.string,
  error: _propTypes.default.bool,
  errorMessage: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  type: _propTypes.default.string
};